<template>
    <div class="counterparty">
        <div class="panel  sluzebka">
            <make_doc_title
                title="Чорний список контрагентів для службових по оплаті"
                button_action="add_counterparty"
                :button_plus=this.editable
            >
            </make_doc_title>
            <div class="panel-toolbar">
            
            </div>
            <div class="panel-container show">
                <div class="panel-content">
                    <b-form-group
                        label="Фільтр"
                        label-for="filter-input"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                    >
                        <b-input-group size="sm">
                            <b-form-input
                                id="filter-input"
                                v-model="filter"
                                type="search"
                                placeholder="пошук ЄДРПОУ"
                            ></b-form-input>
                            
                            <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Очистити</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                    
                    <b-table
                        head-variant="dark"
                        class="table-responsive-lg w-10 mt-4"
                        striped
                         :items="list_items"
                         :fields="fields"
                         :filter="filter"
                    >
                        
                        <template #cell(delete)="row">
                            <b-button v-if="editable" size="sm" variant="danger" @click="del(row.item)" class="mr-2">
                                Видалити
                            </b-button>
                        </template>
                        
                        <template #cell(info)="row">
                            <b-button size="sm" variant="info" @click="info(row.item)" class="mr-2">
                                Інформація
                            </b-button>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
        
        <company_info></company_info>
        <counterparty_add></counterparty_add>
    </div>
</template>

<script>



import company_info from './company_info.vue';
import Make_doc_title from "../../shared/helpers/make_doc_title.vue";
import Counterparty_add from "./counterparty_add.vue";

export default {
    name: "counterparty_items",
    
    components: {
        Counterparty_add,
        Make_doc_title,
        company_info
    },
    props: {
        editable: Boolean,
    },
    
    data() {
        return {
            list_items: [],
            
            filter: null,
            fields: [
                {
                    key: 'id',
                    sortable: true
                },
                {
                    key: 'edrpou',
                    label: 'ЄДРПОУ',
                    sortable: true
                },
                {
                    key: 'name',
                    label: 'Назва',
                    sortable: true
                },
                
                {
                    key: 'info',
                    label: 'Інформація',
                    
                },
                {
                    key: 'delete',
                    label: 'Видалити',
                    
                },
            ],
        }
    },
    
    computed: {},
    
    created() {
        EventBus.$on('added_cp', e => {
            this.getItems();
        });
        
        EventBus.$on('loaded_counterparty', e => {
            this.updatename(e)
        });
        
        this.getItems();
    },
    
    methods: {
        async getItems() {
            await api.get('/counterparty').then(({data}) => {
                if (data.status == "operation_success") {
                    this.list_items = data.data;
                }
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
        
        async del(row) {
            console.log(row);
            await api.delete('/counterparty/' + row.id).then(({data}) => {
                if (data.status == "operation_success") {
                    this.getItems();
                    EventBus.$emit('show_toast', {err: "Видалено " + row.edrpou, type: "success", title: "OK"});
                }
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
        
        
        async updatename(e) {
            await axios.post('/index.php?option=com_imc_docs&task=counterparty.update', qs.stringify({
                "id": this.$store.state.counterparty.counterparty.id,
                "name": e.udata.companyshort
            })).then(({data}) => {
                if (data.status == "operation_success") {
                    this.getItems();
                }
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
        
        info(row) {
            EventBus.$emit('show_edrpou_info',row.edrpou);
        },
        
    },
}
</script>

<style scoped>

</style>
